export default "__VITE_ASSET__II88361k__"